import { createTheme } from '@mui/material/styles';

const gradients = {
  roxoAzul: 'linear-gradient(135deg, #A44DFF 0%, #00DBFF 100%)',
  azulAzulEscuro: 'linear-gradient(135deg, #00DBFF 0%, #002233 100%)',
};

const activeGradient = gradients[process.env.REACT_APP_BRANDING_GRADIENT]
  || gradients.roxoAzul;

const theme = createTheme({
  status: {
    danger: '#e53e3e',
  },
  palette: {
    primary: {
      main: '#002233',
      darker: '#002233',
    },
    accent: {
      main: '#A44DFF',
    },
    neutral: {
      main: '#64748B',
      contrastText: '#fff',
    },
    text: {
      primary: '#303742',
      secondary: '#767F8D',
    },
    border: {
      main: '#BBBFC6',
    },
    surface: {
      subtle: '#F4F4F4',
    },
    red: {
      main: "#ff0000",
      dark: "#d41313",
      contrastText: '#fff',
    }
  },
  typography: {
    fontFamily: 'TOTVS, Verdana, sans-serif',
  },
  gradients: {
    ...gradients,
    active: activeGradient,
  },
});

export default theme;